import React from 'react'
import ModalGeneric from './modalGeneric'
import { Container } from './styles'
import ButtonV2 from '../button/button_v2'
import { theme } from '../../styles/theme'
import { H5, BodyG, BodyP } from '../../styles/stylesTypography'
import ModalImage from '../../assets/modalRecursoClientes.svg'

const ModalYesNoV2 = ({ image = ModalImage, ...props }) => {

  const updateYes = () => {
    if (props.update) {
      props.update(1)
    }
  }

  const updateNo = () => {
    if (props.update) {
      props.update(0)
    }
  }

  const onHide = () => {
    if (props.onHide) {
      props.onHide()
    } else {
      updateNo()
    }
  }

  return (
    <ModalGeneric
      show={props.show}
      onHide={() => onHide()}
      marginBottom='0'
    >
      <Container>
        <img src={image} alt='Imagem de confirmação' />

        <H5>{props.title || 'Você tem uma compra pendente'}</H5>

        <BodyG color={"#26212F"}>
          {props.text || 'Existe uma compra pendente na sua conta. Deseja substituir por essa nova compra?'}
        </BodyG>

        <BodyP color={"#8A92A2"}>
          {props.subtext || 'Ao confirmar, cancelaremos a sua compra pendente.'}
        </BodyP>

        <div
          className='button-finish'
          style={{
            width: '100%',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            marginTop: '20px',
            gap: '12px',
          }}
        >
          <ButtonV2
            width='48%'
            height='50px'
            value={props.cancelLabel || 'CANCELAR'}
            outline={true}
            disabled={false}
            color={"#26212F"}
            onClick={() => updateNo()}
            loading={false}
          />
          <ButtonV2
            width='48%'
            height='50px'
            value={props.confirmLabel || 'CONFIRMAR COMPRA'}
            outline={false}
            disabled={false}
            onClick={() => updateYes()}
            loading={false}
          />
        </div>
      </Container>
    </ModalGeneric>
  )
}

export default ModalYesNoV2